module.exports = __webpack_public_path__ + "static/media/notifications.e5a47796.svg";